import React from 'react'

const BloodMain = () => {
  return (
    <div id='website-responsive' className=''>
        <div className='bg-img' style={{ backgroundImage:'url("https://unitedlabcare.com/wp-content/uploads/2023/06/Blood-Testing-Banner-v1.webp")', height:'100%', width:'100%'}}>
            <div className='toxicology-text-padding'>
                <div className='-max-width display-none-1150'>
                    <text className='fs-ss-42 text-montserrat fw-700 lh-1-2 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                    BLOOD TESTING LAB<br/>
                    IN CHICAGO, IL
                    </text>
                </div>

                <div className='-max-width display-block-1150'>
                    <text className='fs-ss-32-4 text-montserrat fw-700 lh-1 text-ss-primary' style={{ letterSpacing:'-1px'}}>
                        Blood testing<br/>
                        in Chicago, IL
                    </text>
                </div>
            </div>
        </div>
    </div>
  )
}

export default BloodMain